export const GET_CARDS = "GET_CARDS";
export const GET_CARD_BY_ID = "GET_CARD_BY_ID";
export const UPDATE_CARD = "UPDATE_CARD";
export const DELETE_CARD = "DELETE_CARD";
export const CREATE_CARD = "CREATE_CARD";
export const SET_CARD_AS_FAVORITE = "SET_CARD_AS_FAVORITE";
